/**
 * Currency formatting utilities
 */

/**
 * Formats a number as a currency string with dollar sign and 2 decimal places
 * @param number - The number to format
 * @returns Formatted currency string (e.g., "$10.00")
 */
export const withCurrency = (number: number | string | undefined | null): string => {
  return `$${Number(number).toFixed(2)}`;
};
